import React from "react"
import { FilePropsType } from "./types"

const SVG = (props: FilePropsType) => {
  return <img className={props.className} src={props.file.url} />
}

export default SVG
